module.exports = __webpack_public_path__ + "static/img/8.647ef54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/8.png
// module id = hSB+
// module chunks = 0